// src/components/Timer/SessionLog.js

import React from 'react';

function SessionLog({ sessionLogs = [] }) {
  if (sessionLogs.length === 0) {
    return <div className="empty-log">📭 No sessions logged yet.</div>;
  }

  return (
    <ul className="log-list">
      {sessionLogs.map((entry, index) => {
        // Support both string and object formats
        const message = typeof entry === 'string' ? entry : entry.message;
        const time = typeof entry === 'object' && entry.time ? new Date(entry.time) : null;
        const isValidTime = time && !isNaN(time.getTime());

        return (
          <li key={index} className="log-entry">
            <div className="log-entry-icon">🕒</div>
            <div className="log-entry-text">
              {message}
              {isValidTime && (
                <span className="log-time">
                  {' '}• {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default SessionLog;

